<template>
   <header style="background: url('images/cont.jpg') center no-repeat;" class="page-header">
  <div class="container">
  <h1>CONNECT WITH US</h1>
  </div>
  </header>
<!-- end page-header -->
</template>
<script>

export default {
    
}
</script>